import { animate, style, transition, trigger } from '@angular/animations';
import { NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-actions-button',
  imports: [NgIf, NgFor],
  template: `
    <div class="relative flex-none">
      <button type="button" class="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900 cursor-pointer" (click)="toggleMenu()">
        <span class="sr-only">Open options</span>
        <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
        </svg>
      </button>

      <div
        *ngIf="isOpen"
        @fadeInOut
        class="absolute right-0 z-10 mt-2 w-28 origin-top-right rounded-lg bg-white ring-1 shadow-xl ring-gray-900/5 focus:outline-hidden"
        role="menu"
        aria-orientation="vertical"
        tabindex="-1"
      >
        <button
          *ngFor="let option of options"
          class="w-full block px-3 py-1 text-sm/6 text-gray-900 hover:bg-secondary hover:text-white cursor-pointer transition duration-300 ease-in-out text-left"
          (click)="executeAction(option.action)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  `,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0, transform: 'translateY(0)' }), animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ActionsButtonComponent {
  private _openMenuId: number | null = null;

  @Input() id!: number;
  @Input() set openMenuId(value: number | null) {
    this._openMenuId = value;
  }
  @Input() options: { label: string; action: string }[] = [];
  @Output() toggleMenuEvent = new EventEmitter<number>();
  @Output() executeActionEvent = new EventEmitter<{ action: string; id: number }>();

  constructor(private elementRef: ElementRef) {}

  get isOpen(): boolean {
    return this._openMenuId === this.id;
  }

  toggleMenu(): void {
    this.toggleMenuEvent.emit(this.id);
  }

  executeAction(action: string): void {
    this.executeActionEvent.emit({ action, id: this.id });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this._openMenuId = null;
    }
  }
}
